export const faqs = [
  {
    q: "瓜田社区主要聊些什么？",
    a: "主要围绕今日话题、热帖推荐与讨论版展开，涵盖吃瓜第一线、生活茶话会、职场唠嗑、影视追剧社、兴趣同好圈、情感树洞和美食瓜田等板块，既有热点讨论，也有日常唠嗑，内容丰富但没有攻击性。",
  },
  {
    q: "第一次来，怎么快速参与讨论？",
    a: "可以直接进入讨论版，挑选感兴趣的话题点开回帖。不想回复也没关系，先看热帖榜单了解大家在聊什么，找到有共鸣的话题再发言，不用有压力。",
  },
  {
    q: "发帖有门槛吗？会不会没人理？",
    a: "没有门槛，一句话也能发。值班版主每天会在今日话题下互动，新帖也容易被推荐到热帖榜。标题写清楚、内容真诚，通常都能收到回应。",
  },
  {
    q: "回帖讨论的规则是什么？",
    a: "核心原则是「先聊感受，再谈观点」。允许反驳，但不接受人身攻击、地域歧视和恶意引战。理性讨论、友好补充的楼层会获得更多点赞。",
  },
  {
    q: "社区内容会实时更新吗？",
    a: "今日话题每天更新，热帖推荐根据近期互动、点赞与回帖量动态调整。你还可以在讨论版按板块筛选，快速找到当下最活跃的讨论。",
  },
  {
    q: "遇到不舒服的内容怎么办？",
    a: "可以通过帖子内的举报入口反馈，值班版主每天巡版处理。你也可以在确保不引战的前提下，在回帖里温和地提出不同看法，社区鼓励就事论事。",
  },
];